import React, { useState } from 'react';

import { useIntl } from 'react-intl';
import { Button, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { SectionTitle } from 'components/UI';
import { TasksTable } from 'pages/Dashboard/Common';
import { getTasks, getTasksForTemplate } from 'store/tasks/service';
import { isPatientArchived } from 'store/patient/reducer';
import { useAppSelector } from 'hooks';
import { selectCurrentGid } from 'store/groups/reducer';

import AddEditClinicalTaskModal from './AddEditClinicalTaskModal';
import DeleteClinicalTaskModal from './DeleteClinicalTaskModal';

interface ITasksProps {
  carePlanTemplate?: ICarePlanTemplate;
  carePlan?: ICarePlan;
}

const Tasks = ({ carePlanTemplate, carePlan }: ITasksProps) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const [modal, setModal] = useState<ModalType | null>(null);
  const [targetTask, setTargetTask] = useState<ITask | null>(null);
  const isTemplateGlobal = carePlanTemplate?.template_type === 'GLOBAL';
  const patient = useAppSelector((state) => state.patient.data);
  const gid = useAppSelector(selectCurrentGid);
  const _isPatientArchived = useAppSelector(isPatientArchived);
  const handleClose = (refresh?: boolean) => {
    setModal(null);
    setTargetTask(null);
    if (refresh) {
      dispatch(
        carePlanTemplate !== undefined
          ? getTasksForTemplate({ gid: gid, templateId: carePlanTemplate.template_id })
          : getTasks({
              uid: patient?.uid
            })
      );
    }
  };

  const handleAction = (action: ModalType, task: ITask) => {
    setModal(action);
    setTargetTask(task);
  };

  return (
    <div className="mb-5" data-test="careplan-tasks-section">
      <div className="d-flex justify-content-between align-items-center">
        <SectionTitle dataTestId="careplan-tasks-title" label={formatMessage({ id: 'tasksKey' })} />
        {!isTemplateGlobal && (
          <Button
            data-test="careplan-add-task-btn"
            variant="link"
            size="sm"
            onClick={() => setModal('add')}
            disabled={_isPatientArchived}
          >
            + {formatMessage({ id: 'taskKey' })}
          </Button>
        )}
      </div>
      <Row>
        <TasksTable
          variant="careplan"
          handleAction={handleAction}
          carePlanTemplate={carePlanTemplate}
          carePlan={carePlan}
          disabled={_isPatientArchived}
        />
      </Row>

      {(modal === 'add' || modal === 'edit') && (
        <AddEditClinicalTaskModal
          handleClose={handleClose}
          task={targetTask}
          carePlanTemplate={carePlanTemplate}
        />
      )}
      {modal === 'delete' && (
        <DeleteClinicalTaskModal
          handleClose={handleClose}
          task={targetTask}
          carePlanTemplate={carePlanTemplate}
        />
      )}
    </div>
  );
};

export default Tasks;
